<template lang="pug">
.loan-summary
    .own-funds.loan-result-row
      .loan-result-text {{ $t('loan.ownFunds') }}
      .loan-result-amount.amount-value.m {{ formatNumberToString(ownFunds) }}
    .monthly-cost.loan-result-row
      .loan-result-text {{ $t('loan.monthlyCost') }}
      .loan-result-amount.amount-value.m {{ formatNumberToString(monthlyCost) }}
    .monthly-cost.loan-result-row(v-if="repayable")
      .loan-result-text {{ $t('loan.repayable') }}
      .loan-result-amount.amount-value.m {{ formatNumberToString(repayable) }}
    .monthly-cost.loan-result-row(v-if="apr")
      .loan-result-text {{ $t('loan.apr') }}
      .loan-result-amount.amount-value.m {{ formatPercentageToString(apr) }}
    .monthly-cost.loan-result-row(v-if="fixedFee")
      .loan-result-text {{ $t('loan.fee') }}
      .loan-result-amount.amount-value.m {{ formatNumberToString(fixedFee) }}
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { formatPercentageToString, formatNumberToString } from "@/helpers";
export default defineComponent({
  name: "LoanSummary",
  props: {
    ownFunds: {
      type: Number,
      required: true,
    },
    monthlyCost: {
      type: Number,
      required: true,
    },
    repayable: {
      type: Number,
      required: false,
    },
    apr: {
      type: Number,
      required: false,
    },
    fixedFee: {
      type: Number,
      required: false,
    },
  },
  setup() {
    return {
      formatNumberToString,
      formatPercentageToString,
    };
  },
});
</script>
<style lang="scss">
.loan-summary {
  cursor: default;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  .loan-result-row {
    display: flex;
    justify-content: space-between;
  }
}
</style>
